import api from '@shared/services/api';

export const majorContractsService = {
    getMajorContractById: async (id) => {
        const response = await api.get(`/hr-contract-law-reasons/${id}`);
        return response.data;
    },
    getMajorContracts: async (params = {}) => {
        const queryParams = new URLSearchParams();
        
         if (params.pageNumber !== undefined)queryParams.append('page', params.pageNumber);
        if (params.pageSize !== undefined) queryParams.append('size', params.pageSize);
        if (params.sortBy) queryParams.append('sortBy', params.sortBy);
        if (params.sortDir) queryParams.append('sortOrder', params.sortDir);
        
        // Handle search query
        if (params.searchQuery && typeof params.searchQuery === 'object') {
            Object.entries(params.searchQuery).forEach(([key, value]) => {
                if (value) queryParams.append(key, value);
            });
        }
        
        // Handle active filter
        if (params.active !== undefined && params.active !== null) {
            queryParams.append('active', params.active);
        }
        
        const queryString = queryParams.toString();
        const url = `/hr-contract-law-reasons${queryString ? `?${queryString}` : ''}`;
        const response = await api.get(url);
        return response.data;
    },
    getHrNssiReasons: async () => {
        const response = await api.get('/hr-nssi-reason/1');
        return response.data;
    },
    createMajorContract: async (data) => {
        const response = await api.post('/hr-contract-law-reasons', data);
        return response.data;
    },
 
    updateMajorContract: async (id, data) => {
        const response = await api.put(`/hr-contract-law-reasons/${id}`, data);
        return response.data;
    },
    deleteMajorContract: async (id) => {
        const response = await api.delete(`/hr-contract-law-reasons/${id}`);
        return response.data;
    },
    getTranslation: async (id) => {
        const response = await api.get(`/hr-contract-law-reasons/translation/${id}`);
        return response.data;
    },
    saveTranslation: async (data) => {
        const response = await api.post('/hr-contract-law-reasons/translate', data);
        return response.data;
    },
    getMajorContractsReportData: async (params = {}) => {
        const queryParams = new URLSearchParams();
        
        // Handle search query
        if (params.searchQuery && typeof params.searchQuery === 'object') {
            Object.entries(params.searchQuery).forEach(([key, value]) => {
                if (value) queryParams.append(key, value);
            });
        }
        
        // Handle active filter
        if (params.active !== undefined && params.active !== null) {
            queryParams.append('active', params.active);
        }
        
        const queryString = queryParams.toString();
        const url = `/hr-contract-law-reasons/report${queryString ? `?${queryString}` : ''}`;
        const response = await api.get(url);
        return response.data || [];
    },
    // Contract type specific methods
    getLaborContractReasons: async () => {
        const response = await api.get('/hr-contract-law-reasons-list');
        return response.data || [];
    },
    getAdditionalAgreementReasons: async () => {
        const response = await api.get('/hr-anex-law-reasons-list');
        return response.data || [];
    },
    getAdditionalLaborContractReasons: async () => {
        const response = await api.get('/hr-contract-law-reason-additional-work-list');
        return response.data || [];
    },
    getTerminationReasons: async () => {
        const response = await api.get('/hr-leave-law-reasons-list');
        return response.data || [];
    },
    //Register Form
    getAdditionalAgreementContractsById: async (id) => {
        const response = await api.get(`/emp-contracts/${id}`);
        return response.data || [];
    },
    changeContractNumber: async (id, contractNo) => {
        const params = new URLSearchParams({ contractNo: String(contractNo) });
        const response = await api.patch(`/emp-contracts/change-no/${id}?${params.toString()}`);
        return response.data;
    },
    activateContract: async (id) => {
        const response = await api.patch(`/emp-contracts/activate/${id}`);
        return response.data;
    },
    confirmContract: async (id) => {
        const response = await api.patch(`/emp-contracts/confirm/${id}`);
        return response.data;
    },
    eraseContract: async (id) => {
        const response = await api.patch(`/emp-contracts/erase/${id}`);
        return response.data;
    },
    removeContract: async (id) => {
        const response = await api.delete(`/emp-contracts/${id}`);
        return response.data;
    },
    refuseContract: async (id) => {
        const response = await api.patch(`/emp-contracts/refuse/${id}`);
        return response.data;
    },
    createAdditionalAgreement: async (data) => {
        const response = await api.post('/emp-contracts', data);
        return response.data;
    },
    getMainContractsByPersonId: async (id) => {
        const response = await api.get(`/emp-main-contracts/${id}`);
        return response.data || [];
    },
    getContractById: async (id) => {
        const response = await api.get(`/emp-contract-by-id/${id}`);
        return response.data;
    },
    getEmpAdditionalAttributesByContractId: async (contractId) => {
        const response = await api.get(`/emp-add-attr/${contractId}`);
        return response.data || [];
    },
    saveEmpAdditionalAttributes: async (data) => {
        const response = await api.put('/emp-add-attr', data);
        return response.data;
    },
    getHrDocTemplates: async (params = {}) => {
        const queryParams = new URLSearchParams();
        if (params.typeDoc) queryParams.append('typeDoc', params.typeDoc);

        const queryString = queryParams.toString();
        const url = `/hr-doc-templates${queryString ? `?${queryString}` : ''}`;
        const response = await api.get(url);
        return response.data || [];
    },
    generateContractReport: async (reportId, contractId) => {
        const queryParams = new URLSearchParams();
        if (reportId !== undefined && reportId !== null) queryParams.append('reportId', reportId);
        if (contractId !== undefined && contractId !== null) queryParams.append('contractId', contractId);
        const queryString = queryParams.toString();
        return api.get(`/generate-report${queryString ? `?${queryString}` : ''}`, {
            responseType: 'blob',
        });
    },
    generateIdmInterface: async (contractId) => {
        const response = await api.post(`/idm-interface/${contractId}`);
        return response.data;
    },
    sendFirstEmail: async (contractId) => {
        const response = await api.post(`/send-first-email/${contractId}`);
        return response.data;
    },
    sendSecondEmail: async (personId) => {
        const response = await api.post(`/send-second-email/${personId}`);
        return response.data;
    },
    updateContract: async (id, data) => {
        const response = await api.put(`/emp-contracts/${id}`, data);
        return response.data;
    },
    createWorkExperience: async (data) => {
        const response = await api.post('/hr-length-service', data	);
        return response.data;
    },
    getWorkExperience: async (empId) => {
        const response = await api.get(`/hr-length-service/${empId}`);
        return response.data || [];
    },
    // hr-length-service-correct: GET and POST for correction table (kind 0 = Общ трудов стаж, kind 1 = Професионален стаж)
    getLengthServiceCorrect: async (empId, kind) => {
        const response = await api.get(`/hr-length-service-correct/${empId}?kind=${kind}`);
        return response.data || [];
    },
    createLengthServiceCorrect: async (data) => {
        const response = await api.post('/hr-length-service-correct', data);
        return response.data;
    },
    updateLengthServiceCorrect: async (id, data) => {
        const response = await api.put(`/hr-length-service-correct/${id}`, data);
        return response.data;
    },
    deleteLengthServiceCorrect: async (id) => {
        const response = await api.delete(`/hr-length-service-correct/${id}`);
        return response.data;
    },
    // hr-length-service-tbl: GET and POST for kind 2 (стаж във фирмата) and kind 3 (професионален стаж)
    getLengthServiceTbl: async (id, kind) => {
        const response = await api.get(`/hr-length-service-tbl/${id}?kind=${kind}`);
        return response.data || [];
    },
    createLengthServiceTbl: async (data) => {
        const response = await api.post('/hr-length-service-tbl', data);
        return response.data;
    },
    updateLengthServiceTbl: async (id, data) => {
        const response = await api.put(`/hr-length-service-tbl/${id}`, data);
        return response.data;
    },
    deleteLengthServiceTbl: async (id) => {
        const response = await api.delete(`/hr-length-service-tbl/${id}`);
        return response.data;
    },
}